import { render, staticRenderFns } from "./SwitchGuide.vue?vue&type=template&id=721c16e2&scoped=true&"
import script from "./SwitchGuide.vue?vue&type=script&lang=js&"
export * from "./SwitchGuide.vue?vue&type=script&lang=js&"
import style0 from "./SwitchGuide.vue?vue&type=style&index=0&id=721c16e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c16e2",
  null
  
)

export default component.exports